import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const NotFoundQueryConversations = ({
    query,
}: {
    query: string | undefined;
}) => {
    const { t } = useTranslation();

    return (
        <Box pb={2} pt={2} px={2} textAlign="center" data-testid="not-found">
            <Typography color="textPrimary" gutterBottom variant="h4">
                {t('Chat.NotFound')}
            </Typography>
            <Typography color="textSecondary" variant="body2">
                {query
                    ? `${t('Chat.Message')} ${query} ${t('Chat.Message2')}`
                    : t('Chat.Empty')}
            </Typography>
        </Box>
    );
};
